import lifeProposal0 from './life-proposal0.png'
import lifeProposal1 from './life-proposal1.png'
import lifeProposal2 from './life-proposal2.png'
import lifeProposal3 from './life-proposal3.png'
import lifeProposal4 from './life-proposal4.png'
import lifeProposal5 from './life-proposal5.png'
import lifeProposal6 from './life-proposal6.png'
import lifeProposal7 from './life-proposal7.png'

let lifeProposalList = [
    {
        title: "FireTV Stickに対応！Kaiteki TVをダウンロードして、持ち運びに便利なTVに！",
        msg: 'FireTV stickを既にお持ちであれば、追加コストゼロ！旅行や出張、行く先々のTVに差しこむだけで、日本の地上波、BS、CS放送がお楽しみいただけます！',
        image: lifeProposal0 
    },
    {
        title: "iOS、Androidスマホアプリはミラーリンクに対応。大画面テレビに簡単接続！",
        msg: '同じネットワーク上で、スマホの画面をご自宅のTVにミラーリング！テレビ離れの世代でも、簡単操作であなたのリビングがホームシアターに！',
        image: lifeProposal1
    },
    {
        title: "スマホアプリは予約録画対応、好きな番組を録画してオフラインでも視聴！",
        msg: '過去4週間から1週間先までの全番組から好きな番組を予約録画。これなら飛行機での長旅も、お気に入りの動画で有意義な時間に！',
        image: lifeProposal2 
    },
    {
        title: "iPhone/iPad/Android/AmazonHDマルチデバイスに対応！シンプルなUIで使い勝手さは抜群！",
        msg: 'シンプルUIを採用。キッチンでレシピ動画を確認するのもよし！ベッドでリラックスしながら映画を楽しむのもよし！楽しみ方は無限大！',
        image: lifeProposal3
    },
    {
        title: "Google Play対応のスマートTVに対応。自宅のスマートTVで簡単に日本のテレビ視聴。",
        msg: '追加投資の必要なし！Kaiteki TVのテレビアプリをダウンロードだけで、日本のテレビが48局視聴できるスグレモノに早変わり！',
        image: lifeProposal4 
    },
    {
        title: "Chromecast with Google TVにも対応。アプリをダウンロードして、持ち運びに便利なTVに！",
        msg: '旅行、出張、行く先々のTVに差しこむだけで、手軽にGoogleTV、 日本の地上波、BS、CS放送がお楽しみいただけます！',
        image: lifeProposal5
    },
    {
        title: "直近30分のタイムシフト視聴や、過去4週間全番組の見逃し視聴はもう常識！",
        msg: '観たい番組を見逃した、時差の関係で夜中に…、そんな心配はご無用！いつでも好きな時に好きな番組を選んで視聴できる利用者目線の充実機能！',
        image: lifeProposal6 
    },
    {
        title: "Kaiteki TVを見ながら、同画面上で人気番組のオンデマンドや、過去番組の検索も！",
        msg: '次世代テレビアプリの操作性は、あなたのテレビライフをもっと快適に！そして、あなたの海外生活をより充実した毎日に！！',
        image: lifeProposal7
    },
]
export default lifeProposalList